import _ from 'lodash';
import makeInitialState from './initialState';

function replaceRecording(recordings, recordingId, updater) {
  const recordingIx = _.findIndex(recordings, { _id: recordingId });
  const recording = updater(recordings[recordingIx]);
  return [
    ...recordings.slice(0, recordingIx),
    recording,
    ...recordings.slice(recordingIx + 1),
  ];
}

export default {
  setRecording(state, payload) {
    if (!_.find(state.allRecordings, { _id: payload._id })) {
      state.allRecordings.push(payload);
    }
    state.currentId = payload._id;
    state.status.recording = 'Fetched';
    state.recordingStart = new Date(payload.videos[0].start).getTime();
    state.recordingEnd = new Date(payload.videos[0].end).getTime();
    state.recordingDuration = state.recordingEnd - state.recordingStart;
    state.videoReady = false;
    state.videoError = null;
  },
  setRecordings(state, payload) {
    state.allRecordings = payload;
    state.status.allRecordings = 'Fetched';
  },
  setIssues(state, payload) {
    state.issues = payload;
    state.status.issues = 'Fetched';
  },
  setEvents(state, payload) {
    state.events = payload;
    state.status.events = 'Fetched';
  },
  updateVideoTime(state, payload) {
    const { currentVideoTime } = payload;
    state.playbackPosInMS = currentVideoTime * 1000;
  },
  playVideo(state) {
    state.videoPlaying = true;
  },
  pauseVideo(state) {
    state.videoPlaying = false;
  },
  seekingVideo(state) {
    state.seekingVideo = true;
  },
  seekingComplete(state) {
    state.seekingVideo = false;
  },
  selectIssue(state, issueId) {
    state.currentIssueId = issueId;
  },
  aspirationalSeek(state, pos) {
    state.aspirationalSeekMS = pos;
  },
  videoReady(state) {
    state.videoReady = true;
    state.videoError = null;
  },
  videoError(state, err) {
    state.videoError = err;
    state.seekingVideo = false;
  },
  CLEAR(state) {
    Object.assign(state, makeInitialState());
  },
  UPDATING(state, { recordingId, name }) {
    state.allRecordings = replaceRecording(
      state.allRecordings,
      recordingId,
      r => _.omit({ ...r, name, updating: true, oldName: r.name }, 'error'),
    );
  },
  UPDATED(state, { recordingId }) {
    state.allRecordings = replaceRecording(
      state.allRecordings,
      recordingId,
      r => _.omit({ ...r, updating: false }, 'error', 'oldName'),
    );
  },
  UPDATE_ERROR(state, { recordingId, error }) {
    state.allRecordings = replaceRecording(
      state.allRecordings,
      recordingId,
      r => ({ ...r, name: r.oldName, updating: false, error }),
    );
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/recordings/mutations.js